import { useState } from 'react';

// A piece of report state that survives switching reports and coming back, per browser. Only for
// conveniences like which month is being looked at: nothing here is data, and it is fine for it to
// come back empty (a private window, cleared site data), which is why every access is guarded.

const useLocalState = (key, initial) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(`clinic_report:${key}`);
      if (stored) return stored;
    } catch {
      // Site data blocked or unavailable: fall through to the default.
    }
    return typeof initial === 'function' ? initial() : initial;
  });

  const set = (next) => {
    setValue(next);
    try {
      window.localStorage.setItem(`clinic_report:${key}`, next);
    } catch {
      // Nothing to do: the choice simply will not be remembered.
    }
  };

  return [value, set];
};

export default useLocalState;
